import { slugify } from './functionalUtils';

const TEAM_MAP = {
  aik: 'aik',
  bkh: 'bk-hacken',
  deif: 'degerfors-if',
  dif: 'djurgardens-if',
  gbg: 'ifk-goteborg',
  ham: 'hammarby-if',
  hbk: 'halmstads-bk',
  ifbp: 'if-brommapojkarna',
  ife: 'if-elfsborg',
  iks: 'ik-sirius',
  kff: 'kalmar-ff',
  maif: 'mjallby-aif',
  mff: 'malmo-ff',
  nor: 'ifk-norrkoping',
  var: 'varbergs-bois',
  varn: 'ifk-varnamo',
  afc: 'afc-eskilstuna',
  gais: 'gais',
  gif: 'gefle-if',
  hif: 'helsingborg',
  ikb: 'ik-brage',
  jon: 'jonkopings-sodra',
  lan: 'landskrona-bois',
  ofk: 'ostersunds-fk',
  oif: 'osters-if',
  ois: 'orgryte-is',
  osk: 'orebro-sk',
  skaik: 'skovde-aik',
  sun: 'gif-sundsvall',
  tff: 'trelleborgs-ff',
  ubk: 'utsiktens-bk',
  vsk: 'vasteras-sk',
  sandif: 'sandif',
  iko: 'iko',
};

export const getTeamUrl = (id) =>
  String(id) ? `/lagen/${TEAM_MAP[String(id).toLowerCase()]}` : false;

export const getPlayerUrl = (teamId, displayName) =>
  teamId && displayName
    ? `/lagen/${TEAM_MAP[teamId.toLowerCase()]}/${slugify(displayName)}`
    : '';
export const getPlayerUrlById = (id) => (id ? `/spelare/${id}` : '');

export const getMatchUrl = (season, matchId, homeTeamName, visitingTeamName) =>
  `/matcher/${season}/${matchId}/${slugify(homeTeamName)}-mot-${slugify(
    visitingTeamName
  )}`;
